var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.24707 0.708984C2.73457 0.708984 1.49707 1.94648 1.49707 3.45898H2.87207C2.87207 2.68898 3.47707 2.08398 4.24707 2.08398C5.01707 2.08398 5.62207 2.68898 5.62207 3.45898V6.20898H0.12207V11.709H8.37207V6.20898H6.99707V3.45898C6.99707 1.94648 5.75957 0.708984 4.24707 0.708984Z",
    fill: "#0D2045"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpen);
export default __webpack_public_path__ + "static/media/lockOpen.4406714ab4066dad69079fa0d058a636.svg";
export { ForwardRef as ReactComponent };